import { useEffect } from 'react';

const useCheckUserBlocks = ({
  currentUser,
  totalBathesNumber,
  marketingData,
  game,
  hasSignUpBlock,
  setHasSignUpBlock,
  hasEmailConfirmationBlock,
  setHasEmailConfirmationBlock,
  hasSubscription,
  hasSubscriptionBlock,
  setHasSubscriptionBlock,
}) => {
  useEffect(() => {
    if (
      !currentUser &&
      (Number(totalBathesNumber) >= Number(marketingData?.chat_signup_batches_number) ||
        (game && !game?.isFree))
    ) {
      if (hasSignUpBlock) {
        return;
      }
      setHasSignUpBlock(true);
    }

    if (currentUser && !currentUser?.emailVerified) {
      if (hasEmailConfirmationBlock) {
        return;
      }
      setHasEmailConfirmationBlock(true);
    }

    if (
      currentUser &&
      !hasSubscription &&
      (Number(totalBathesNumber) > Number(marketingData?.chat_subscription_batches_number) ||
        (game && !game?.isFree))
    ) {
      if (hasSubscriptionBlock) {
        return;
      }
      setHasSubscriptionBlock(true);
    }
  }, [currentUser, totalBathesNumber, marketingData]);
};

export default useCheckUserBlocks;